import { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useQuery } from 'react-query';

import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';
import DateTypeSelectFilter from 'components/dashboard/items/dateTypeSelectFilter';
import useTopPanel from 'hooks/useTopPanel';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import WarehouseFilter from 'components/ui/filters/items/WarehouseFilter';
import { useLocation } from 'react-router-dom';
import Products from './items/Products';
import Incomes from './items/Incomes';

const Dashboard = () => {
  const axiosPrivate = useAxiosPrivate();
  const { setComponent } = useTopPanel();
  const { search } = useLocation();
  const [open, setOpen] = useState(false);
  const [hasError, setHasError] = useState(false);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['/admin/orders/edit', search],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/admin/main/main${search ? search : ''}`
      );
      return response.data.data;
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  useEffect(() => {
    setComponent(
      <div className='component-title flex items-center gap-2 whitespace-nowrap'>
        <span>Bosh sahifa</span>
        <div className='min-w-72 ml-2'>
          <DateTypeSelectFilter />
        </div>
        <div className='min-w-72'>
          <WarehouseFilter />
        </div>
        <Button
          variant='base'
          onClick={() => {
            refetch();
          }}
          disable={`${isLoading}`}
        >
          <i
            className={`bi bi-arrow-repeat${isLoading ? ' animate-spin' : ''}`}
          />
        </Button>
      </div>
    );
  }, [isLoading, refetch]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-table-wrapper flex-auto h-[calc(100vh-325px)]'>
        {isLoading ? (
          <div className='h-full w-full flex justify-center items-center'>
            <CircularProgress />
          </div>
        ) : data ? (
          <div className='grid grid-cols-2 gap-4 pt-2'>
            <div
              className='base-border bg-white p-4 shadow-md cursor-pointer hover:shadow-lg'
              onClick={() => setOpen('income')}
            >
              <div className='title text-xl font-semibold'>
                Jami qabul qilingan mahsulotlar
              </div>
              <div className='sum text-[40px] text-green-600 font-semibold flex items-center justify-center h-96'>
                <CurrencyFormat value={data?.income?.totalincome} />
              </div>
            </div>

            <div
              className='base-border bg-white p-4 shadow-md cursor-pointer hover:shadow-lg'
              onClick={() => setOpen('sale')}
            >
              <div className='title text-xl font-semibold'>Savdo</div>
              <div className='sum h-96 flex justify-center items-center flex-col'>
                <div>
                  <div className='text-[40px] text-green-600 font-semibold h-32 flex flex-col justify-center'>
                    <div className='title text-xl font-semibold text-black'>
                      Jami savdo
                    </div>
                    <CurrencyFormat value={data?.sale?.totalsum} />
                  </div>
                  <div className='text-[40px] text-green-600 font-semibold h-32 flex flex-col justify-center'>
                    <div className='title text-xl font-semibold text-black'>
                      Jami foyda
                    </div>
                    <CurrencyFormat value={data?.sale?.profit} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className='my-6'>
            <span className='no-data-found-wrapper'>
              <i className='bi bi-exclamation-octagon text-xl mr-1 leading-3' />{' '}
              Ma'lumot topilmadi!
            </span>
          </div>
        )}
      </div>
      <Incomes data={data} open={open == 'income'} setOpen={setOpen} />
      <Products data={data} open={open == 'sale'} setOpen={setOpen} />
    </div>
  );
};
export default Dashboard;
